module.exports = __webpack_public_path__ + "img/less.39add92e.svg";